import { render, staticRenderFns } from "./LocationServiceAddressesRow.vue?vue&type=template&id=b2db21ca&scoped=true"
import script from "./LocationServiceAddressesRow.vue?vue&type=script&lang=js"
export * from "./LocationServiceAddressesRow.vue?vue&type=script&lang=js"
import style0 from "./LocationServiceAddressesRow.vue?vue&type=style&index=0&id=b2db21ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2db21ca",
  null
  
)

export default component.exports